import React, { FC, useState } from 'react';
import { Alert, Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { RemoveIcon } from '~/img';
import { usePermissions } from '~/hooks';
import { useEmployeesDelete } from '~/hooks/employees';

interface EmployeeDeleteProps {
  id: string;
  closeParent: () => void;
  hasAffiliation?: boolean;
  name?: string;
}

const EmployeeDelete: FC<EmployeeDeleteProps> = (props) => {
  const { id, closeParent, hasAffiliation, name } = props;
  const [t] = useTranslation();

  const { mutate, isLoading } = useEmployeesDelete(closeParent);

  const [visible, setVisible] = useState(false);

  const hasAccess = usePermissions('business.employee.delete');
  if (!hasAccess) return null;

  const showModal = () => setVisible(true);
  const handleOk = () => {
    mutate(id);
    setVisible(false);
  };
  const handleCancel = () => setVisible(false);

  return (
    <>
      <Button danger type="text" icon={<RemoveIcon />} loading={isLoading} onClick={showModal}>
        {t('delete')}
      </Button>
      <Modal
        title={t('deleteTeamMember', { name })}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t('yes')}
        okButtonProps={{ danger: true }}
        cancelText={t('no')}
        confirmLoading={isLoading}
      >
        <>
          {hasAffiliation && (
            <Alert
              type="warning"
              showIcon
              message={t('teamMemberHasAffiliationAlert', { name })}
              style={{ marginBottom: 16 }}
            />
          )}
          {t('areYouSureYouWantTo')}
        </>
      </Modal>
    </>
  );
};

export default EmployeeDelete;
